/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PagingRequestDto
 */
export interface PagingRequestDto {
    /**
     * 
     * @type {number}
     * @memberof PagingRequestDto
     */
    pageIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof PagingRequestDto
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the PagingRequestDto interface.
 */
export function instanceOfPagingRequestDto(value: object): value is PagingRequestDto {
    return true;
}

export function PagingRequestDtoFromJSON(json: any): PagingRequestDto {
    return PagingRequestDtoFromJSONTyped(json, false);
}

export function PagingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pageIndex': json['pageIndex'] == null ? undefined : json['pageIndex'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function PagingRequestDtoToJSON(json: any): PagingRequestDto {
    return PagingRequestDtoToJSONTyped(json, false);
}

export function PagingRequestDtoToJSONTyped(value?: PagingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageIndex': value['pageIndex'],
        'pageSize': value['pageSize'],
    };
}

